var e = ((a) => (a.Default = "default", a.Japanese = "japanese", a.Korean = "ko", a.SimplifiedChinese = "zh-Hans", a.TraditionalChinese = "zh-Hant", a))(e || {});
export {
  e as BrowseMode
};
//# sourceMappingURL=BrowseMode.js.map
